import { setContext } from "svelte";
import { initialState } from "../state/state";
import { writable } from "svelte/store";
import { stateSymbol } from "../context";
export function createStores() {
    let stateStore = writable(initialState);
    setContext(stateSymbol, stateStore);
    // let zoomToFitStore = writable(() => {});
    // setContext(zoomToFitSymbol, zoomToFitStore);
    // let getSVGStore = writable(() => '');
    // setContext(getSVGSymbol, getSVGStore);
}
